import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import { TGenerateReportAPIParams, TShareReportApiParams } from '@app/dashboard/types/innerLayout/reports';
import type { TStatementsListResponse, TDownloadStatementParams } from '@app/dashboard/types/innerLayout/reports';

export const exportReport = (
  dataObj: TGenerateReportAPIParams,
  isLive: boolean
) => {
  const queryParams = {
    is_live: isLive,
  };
  return axiosPrivate.post(`/dashboard/v1/export/report-extended`, dataObj, {
    params: queryParams,
  });
};

export const downloadReport = (download_link: string) => {
  return axiosPrivate.get(download_link, {
    responseType: 'blob',
  });
};

export const getReportsTableData = ({
    currentPage,
    pageSize,
    isLive,
    params = {}
  }
  : {
    currentPage: number,
    pageSize: number,
    isLive: boolean,
    params: Record<string, string | number | boolean>
  }) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params
  };
  return axiosPrivate.get(`/dashboard/v1/reports/list`, { params: queryParams });
};

export const getArchiveTableData = ({
    currentPage,
    pageSize,
    isLive,
    params = {}
  }
  : {
    currentPage: number,
    pageSize: number,
    isLive: boolean,
    params: Record<string, string | number | boolean>
  }) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params
  };
  return axiosPrivate.get(`/dashboard/v1/reports/accept/list`, { params: queryParams });
};

export const getReportTypes = ({ isLive }: { isLive: boolean }) => {
  const params = { is_live: isLive };

  return axiosPrivate.get(`/dashboard/v1/report/types`, { params: params });
};

export const getCustomReportColumns = ({ isLive }: { isLive: boolean }) => {
  const params = { is_live: isLive };

  return axiosPrivate.get(`/config/custom-report-columns/`, { params: params });
};

export const shareReport = (params: TShareReportApiParams ) => {
  return axiosPrivate.post(`/dashboard/v1/export/send_email`, { ...params });
};

export const getReportSecondaryFilters = ({ isLive }: { isLive: boolean }) => {
  const params = { is_live: isLive };

  return axiosPrivate.get(`/dashboard/v1/report/filters`, { params: params });
};

export const getStatementsOrDigestList = ({ currentPage, pageSize, params }: any ) => {
  const { service, isLive } = params;
  const basePath = service === 'Digest' ? 'digest' : 'merchant_statement';
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    platform: 'dashboard',
  }
  return axiosPrivate.get<TStatementsListResponse>(`/dashboard/v1/${basePath}`, { params: queryParams });
};

export const downloadStatementsOrDigest = ({ downloadPath }: TDownloadStatementParams) => {
  return axiosPrivate.get(
    `${downloadPath}`,
    {
      responseType: 'blob',
    }
  );
};
